import React from 'react';
import {useTheme} from "@mui/material/styles";
import Dialog from "@mui/material/Dialog";
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Icon from "@mui/material/Icon";
import {IMsgBoxProps, MsgBoxType} from "./types";
import {SecondaryButton} from "../form";
import  DialogContentText  from '@mui/material/DialogContentText';


export const MessageBox: React.FC<IMsgBoxProps> = (
    {
        isOpen = false,
        onClose,
        title = "",
        message = "",
        type = undefined
    }: IMsgBoxProps
) => {
    const theme = useTheme();

    let iconColor: MsgBoxType = "inherit";
    let iconName: string | undefined = undefined;

    switch (type) {
        case "error":
            iconColor=type;
            iconName="cancel_rounded_icon";
            break;
        case "warning":
            iconColor=type;
            iconName="warning_rounded_icon";
            break;
        case "info":
            iconColor=type;
            iconName="info_rounded_icon";
            break;
        default:
            break;
    }

    const handleClose = () => {
        onClose();
    }

    const handleOk = () => {
        onClose("ok");
    }

    return (
        <Dialog
            open={isOpen}
            onClose={handleClose}
            aria-labelledby="message-box-title"
            aria-describedby="message-box-description"
        >
            <DialogTitle
                id="message-box-title"
                sx={{
                    display: "flex",
                    alignItems: "end",
                    justifyContent: "start"
                }}
            >
                {iconName &&
                    <Icon
                        color={iconColor}
                        sx={{
                            fontSize: theme.spacing(4.5),
                            mr: theme.spacing(3),
                        }}
                    >
                        {iconName}
                    </Icon>
                }
                {title}
            </DialogTitle>
            <DialogContent>
                <DialogContentText id="message-box-description" sx={{whiteSpace: "pre-line"}}>
                    {message}
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <SecondaryButton variant={"outlined"} onClick={handleOk}>OK</SecondaryButton>
        </DialogActions>
      </Dialog>
    );
}